import React from 'react';
import { useTranslation } from 'react-i18next';

import logo from '@/assets/ai_logo.png'

export const BoundlessComputing: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="section-page relative overflow-hidden">
      <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(14,37,84,0.56) 64%, rgba(58,35,161,1) 87%, rgba(130,93,224,1) 100%)' }} />

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="relative rounded-2xl overflow-hidden p-6 sm:p-12">
          <div className="flex flex-col md:flex-row gap-10 items-center">
            <img src={logo} />
            <div className="flex-1">
              <div className="rounded-2xl border border-[#602DDF] px-[clamp(1.25rem,4vw,2rem)] py-2 text-base text-white sm:text-lg">
                {t('boundless-tagline')}
              </div>
              <h2 className="mt-6 text-balance font-bold text-gradient-light text-2xl md:text-3xl">
                {t('boundless-title')}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
